import { Wtn } from '@clubspark-react/ui';
import styles from './wtnTeamBox.module.scss';

export interface WTNBoxProps {
  title?: string;
  tennisNumber?: number;
}

const WTNTeamBox = ({ title, tennisNumber }: WTNBoxProps) => (
  <div className={styles.wtnBoxStyles}>
    <p>{title}</p>
    <Wtn className={styles.wtnStyles} hideMark>
      {tennisNumber ?? 0}
    </Wtn>
  </div>
);

export default WTNTeamBox;
